(function () {
  const desktopQuery = window.matchMedia('(min-width: 990px)');
  const closeTimers = new WeakMap();

  function clearCloseTimer(menuItem) {
    const timer = closeTimers.get(menuItem);
    if (!timer) return;
    window.clearTimeout(timer);
    closeTimers.delete(menuItem);
  }

  function scheduleClose(menuItem) {
    clearCloseTimer(menuItem);
    closeTimers.set(menuItem, window.setTimeout(() => closeMenu(menuItem), 420));
  }

  function closeOtherMenus(currentMenuItem) {
    document.querySelectorAll('.menu_dp_enable.budli-mega-open').forEach((menuItem) => {
      if (menuItem === currentMenuItem) return;
      closeMenu(menuItem);
    });
  }

  function openMenu(menuItem) {
    const details = getMenuDetails(menuItem);
    if (!details) return;

    clearCloseTimer(menuItem);
    closeOtherMenus(menuItem);
    menuItem.classList.add('budli-mega-open');
    details.setAttribute('open', '');
    details.querySelector('summary')?.setAttribute('aria-expanded', 'true');
  }

  function closeMenu(menuItem) {
    const details = getMenuDetails(menuItem);
    clearCloseTimer(menuItem);
    menuItem.classList.remove('budli-mega-open');
    if (!details) return;

    details.removeAttribute('open');
    details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
  }

  function closeAllMenus() {
    document.querySelectorAll('.menu_dp_enable.budli-mega-open').forEach(closeMenu);
  }

  function getMenuDetails(menuItem) {
    return menuItem.querySelector(':scope > header-menu > details')
      || menuItem.querySelector(':scope > details')
      || menuItem.querySelector('header-menu > details')
      || menuItem.querySelector('details');
  }

  function initMegaMenuHover() {
    if (!desktopQuery.matches) return;

    document.querySelectorAll('.menu_dp_enable').forEach((menuItem) => {
      if (menuItem.dataset.budliHoverReady === 'true') return;
      menuItem.dataset.budliHoverReady = 'true';

      menuItem.addEventListener('mouseenter', () => openMenu(menuItem));
      menuItem.addEventListener('mouseleave', () => scheduleClose(menuItem));
      menuItem.querySelector('.header__submenu')?.addEventListener('mouseenter', () => clearCloseTimer(menuItem));
      menuItem.querySelector('.header__submenu')?.addEventListener('mouseleave', () => scheduleClose(menuItem));
      menuItem.querySelector('summary')?.addEventListener('focus', () => openMenu(menuItem));
      menuItem.addEventListener('focusout', (event) => {
        if (event.relatedTarget && menuItem.contains(event.relatedTarget)) return;
        scheduleClose(menuItem);
      });
    });
  }

  document.addEventListener('click', (event) => {
    if (!desktopQuery.matches) return;
    if (event.target.closest('.menu_dp_enable')) return;
    closeAllMenus();
  });

  document.addEventListener('keyup', (event) => {
    if (event.code !== 'Escape') return;
    closeAllMenus();
  });

  function resetMenusForViewport() {
    if (desktopQuery.matches) {
      initMegaMenuHover();
      return;
    }

    closeAllMenus();
  }

  document.addEventListener('DOMContentLoaded', resetMenusForViewport);
  desktopQuery.addEventListener?.('change', resetMenusForViewport);
})();
